import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';

@Component({
  selector: 'app-player',
  templateUrl: './player.component.html'
})
export class PlayerComponent implements OnInit {
  id1 = 'player1';
  id2 = 'player2';
  id3 = 'player3';
  id4 = 'player4';
  audioUrl1 = '/assets/defaults/audio/sample-audio-1.mp3'; 
  audioUrl2 = '/assets/defaults/audio/sample-audio-2.wav';
  audioUrl3 = '/assets/defaults/audio/sample-audio-3.ogg';
  showDefaultPlayer: boolean = false;
  
  constructor(@Inject(PLATFORM_ID) platformId: Object) {
		this.showDefaultPlayer = !isPlatformBrowser(platformId);
  }

  ngOnInit(): void {
  }

}
